<div class="dialog-content flex-col w-100 justify-stretch items-stretch">
  <h2 mat-dialog-title>{{title}}</h2>
  <mat-dialog-content>
    <div class="w-100 mt-3">
      <form [formGroup]="addressForm" class="flex-col">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Street</mat-label>
          <input matInput autocomplete="off" formControlName="streetAddress1">
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>City</mat-label>
          <input matInput autocomplete="off" formControlName="city">
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Zip Code</mat-label>
          <input matInput autocomplete="off" formControlName="zipCode">
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>State</mat-label>
          <mat-select formControlName="state" (selectionChange)="onSelectState()">
            @for (state of states; track state.id) {
              <mat-option [value]="state">
                {{state.name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>County</mat-label>
          <mat-select formControlName="county" (selectionChange)="onSelectCounty()">
            @for (county of counties; track county.id) {
              <mat-option [value]="county">
                {{county.name}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>

      </form>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="flex-row space-between items-center w-100 mt-3">
      <button mat-flat-button class="w-49" color="primary" (click)="onConfirmClick()" tabindex="1" >{{confirmButtonText}}</button>
      <button mat-flat-button class="w-49" color="primary" (click)="onCancelClick()" >{{cancelButtonText}}</button>
    </div>
  </mat-dialog-actions>
</div>